<mat-toolbar class="topbar">
  <button mat-icon-button (click)="toggleMenu.emit()" aria-label="Menú">
    <mat-icon class="icon-menu">menu</mat-icon>
  </button>

  <span class="title">Tand HN</span>
  <span class="spacer"></span>

  <!-- Botón que dispara el menú -->
  <button mat-button [matMenuTriggerFor]="userMenu">
    <mat-icon>account_circle</mat-icon>
    Perfil
  </button>

  <!-- Definición del menú (no se ve hasta que haces clic) -->
  <mat-menu #userMenu="matMenu" xPosition="before">
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="authService.logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Cerrar Sesión</span>
    </button>
  </mat-menu>
</mat-toolbar>
